import React from "react";
import { NavWrap } from "./ShopForTyres";
import Close from "./../assets/cancel.svg";
import Download from "./../assets/white-download.svg";

const CreateBulk = () => {
  return (
    <NavWrap>
      <div className="m2 claim-card p1 pl2 bulk-order">
        <span className="close">
          <img src={Close} alt="close" width={15} />
        </span>
        <h3>Create Bulk Order - Select File</h3>
        <div className="d-flex">
          <div className="br-right pr2">
            <div className="d-flex mt2 sample-download">
              <button>Sample download file</button>
              <span className="ml1">
                Note: Sample file are the plain template without the data
              </span>
            </div>
            <p>
              Download a sample .csv format or .xls format file and compare it
              to your import file to ensure that the file is ready to import.
            </p>
            <div className="mt2">
              <label className="label">
                Upload file <sup>*</sup>
              </label>
              <div className="upload-input">
                <input />
                <button>
                  <img
                    src={Download}
                    alt="download"
                    width={12}
                    className="mr1"
                  />
                  Choose file
                </button>
              </div>
              <span className="ml1 dim-note">
                Maximum File Size: 5 MB | File Format: CSV or TSV or XLS
              </span>
            </div>
            <div className="mt3">
              <button className="cancel-btn mr2">Cancel</button>
              <button className="primary-btn">Upload</button>
            </div>
          </div>
          <div className="m2 page-tips">
            <h3>Page tips</h3>
            <ul>
              <li>
                - Download the sample file by clicking on Sample File Button
              </li>
              <li>- Enter the order required details on the file.</li>
              <li>
                - If you have files in other formats, you can convert it to an
                accepted file format using any online/offline converter.
              </li>
              <li>- Upload the same file format.</li>
            </ul>
          </div>
        </div>
      </div>
    </NavWrap>
  );
};

export default CreateBulk;
